/**
 * Copyright SimVentions, Inc. Usage, distribution, transferal, and licensing
 * of this source code is protected under SBIR law as described in DFARS 252.227-7018.
 *
 * SBIR data rights fully described in the README.md file in the top level directory of this project.
 */
import inputNodeOneUrl from "url:../assets/images/input_node_1.png";
import inputNodeTwoUrl from "url:../assets/images/input_node_2.png";

export const inputNodesContent = `
## Summary

Input nodes represent your source data files in Dexter.  They are the starting point of any transformation workflow.

Dexter parses the imported source file and displays its data as a hierarchical parent-child structure within the input node.

Dexter identifies each data element that can participate in a transformation by a circular connection handle, which users drag to connect the element to a transform node.

Input nodes also have a "parent handle" used for full-file transformation.


### Anatomy

<img src="${inputNodeOneUrl}" alt="Input Node anatomy" style="max-width: 300px; height: auto; display: block; margin: 24px auto;" />

- **1** - Node data type indicator
- **2** - Node title
- **3** - Overflow menu
- **4** - Button to display source code
- **5** - Parent handle (for full-file transforms)
- **6** - Granular handle (for granular transforms)
- **7** - Search box
- **8** - Node data entry, collapsible

### Adding Input Nodes

There are several ways to add input nodes to your canvas:

1. **Drag and Drop**: Drag files directly from the inputs sidebar onto the canvas
2. **Upload**: Use the upload button to add new files to your project
3. **Collections**: Drag entire collections of related files

### Filtering Input Nodes

To filter an input node, type a value into the \`Find...\` box. The fields that do not
match the value will be hidden. The search value is applied to both types and names.
For example, filtering on "string" will show all string fields in a Protobuf file as well
as a numeric field named "numberOfStrings".

Filtering input nodes does not affect final output. Fields that were connected to
transform nodes will remain connected even if hidden.'

### Overflow Menu

<img src="${inputNodeTwoUrl}" alt="Input Node overflow menu" style="max-width: 300px; height: auto; display: block; margin: 24px auto;" />

- **update title** - Edit the title of the input node
- **remove node** - Deletes the node from the transform canvas
- **hide search** - Toggles the visibility of the search box. Displays "show search" when hidden

### Supported File Types

Dexter's parser currently supports the following file types:

- **XML**: Extensible Markup Language files
- **Protobuf**: Protocol Buffer files

### Input Node Properties

Each input node displays:
- File name
- File type
- Connection handles for linking to transforms

### Best Practices

- Use descriptive file names
- Organize related files into collections
- Verify file types are correctly detected
- Keep your inputs list organized by removing unused files
`;
